import { Block, Group, Document } from "@/types/document";

export interface TableOfContentNode {
  id: string;
  title: string;
  level: number;
  children: TableOfContentNode[];
  group?: Group;
  block?: Block;
}

// Helper function to check if a block is a header type
const isHeaderType = (type: Block["type"]): boolean => {
  return (
    type === "header1" ||
    type === "header2" ||
    type === "header3" ||
    type === "header4"
  );
};

export const resolveGroupedRoots = (doc: Document): TableOfContentNode[] => {
  const roots: TableOfContentNode[] = [];
  doc.groups.forEach((group) => {
    const groupNode: TableOfContentNode = {
      id: group.id,
      title: group.title,
      level: 1,
      children: [],
      group,
    };

    const headerBlocks = group.blockIds
      .map((blockId) => doc.blocks.find((block) => block.id === blockId))
      .filter((block) => block && block.value && isHeaderType(block.type)) as Block[];

    const stack: TableOfContentNode[] = [];
    headerBlocks.forEach((block) => {
      const headerLevel = parseInt(block.type.replace("header", ""));
      const level = headerLevel + 1; // groups are level 1

      const node: TableOfContentNode = {
        id: block.id,
        title: block.value,
        level,
        children: [],
        group,
        block,
      };

      while (stack.length > 0 && stack[stack.length - 1].level >= level) {
        stack.pop();
      }

      if (stack.length === 0) {
        groupNode.children.push(node);
      } else {
        stack[stack.length - 1].children.push(node);
      }

      stack.push(node);
    });

    roots.push(groupNode);
  });
  return roots;
};

export const resolveHeaderRoots = (doc: Document): TableOfContentNode[] => {
  const roots: TableOfContentNode[] = [];
  const allHeaderBlocks = doc.blocks.filter((block) => block.value && isHeaderType(block.type)) as Block[];

  const stack: TableOfContentNode[] = [];
  allHeaderBlocks.forEach((block) => {
    const level = parseInt(block.type.replace("header", ""));
    const node: TableOfContentNode = {
      id: block.id,
      title: block.value,
      level,
      children: [],
      block,
    };

    while (stack.length > 0 && stack[stack.length - 1].level >= level) {
      stack.pop();
    }

    if (stack.length === 0) {
      roots.push(node);
    } else {
      stack[stack.length - 1].children.push(node);
    }

    stack.push(node);
  });

  return roots;
};
